import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) { }
  
  public forgetPassword(forgetPasswordForm: any) {
    return this.http.post(`${environment.apiUrl}/public/users/forgetPassword`, JSON.stringify(forgetPasswordForm));
  }
  
  public resetPassword(resetPasswordForm: any) {
    return this.http.post(`${environment.apiUrl}/public/users/resetPassword`, JSON.stringify(resetPasswordForm));
  }
}